var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTenantsSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 51,
    viewBox: "0 0 23 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.756624 31.3602L0.756761 31.3591L1.53215 24.947C1.53218 24.9467 1.5322 24.9465 1.53223 24.9463C1.97197 21.3643 4.95903 18.6987 8.44503 18.6987H13.8731H13.8732C17.3601 18.6987 20.3467 21.3646 20.7868 24.9471L20.7868 24.9471L20.7881 24.9567L21.6595 31.3642C21.7032 31.7403 21.408 32.189 20.9827 32.3113C20.4254 32.4059 19.8529 32.503 19.2802 32.6001C18.6908 32.7 18.1012 32.7999 17.528 32.8973L16.9395 32.9973L16.9048 33.5932L16.0332 48.582C15.9644 49.3761 15.3192 49.9576 14.5521 49.9576H7.86357C7.09663 49.9576 6.45124 49.3755 6.38248 48.582L5.51081 33.5932L5.47615 32.9973L4.88766 32.8973C4.45381 32.8236 4.04383 32.7659 3.64619 32.7099C2.89853 32.6046 2.1945 32.5055 1.45748 32.3179L1.44752 32.3154L1.43749 32.3132C0.961739 32.2059 0.704059 31.7894 0.756624 31.3602Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5259 8.46621C18.5259 12.3369 15.3885 15.4749 11.5172 15.4749C7.64662 15.4749 4.50854 12.3368 4.50854 8.46621C4.50854 4.5949 7.64657 1.45752 11.5172 1.45752C15.3886 1.45752 18.5259 4.59485 18.5259 8.46621Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantsSelected);
export default __webpack_public_path__ + "static/media/tenants-selected.be873193036a75ec7d44181fe14949af.svg";
export { ForwardRef as ReactComponent };